import React from 'react'
import { HighlightedText, WorkspaceLogo } from '@sketch/components'
import { TreeNode } from '../TreeNode'
import { useTreeNodeChildren } from '../state/useTreeNodeChildren'
import { Icon } from '../TreeNode.styles'
import { ProjectIcon } from '../../../components/ProjectIcon'
import { InView } from 'react-intersection-observer'

interface NodeProps {
  id: string
  depth: number
  search: string
  lastItemId: string
  onLastItemVisible: () => void
}
export const Node = (props: NodeProps) => {
  const { id, depth, search, lastItemId, onLastItemVisible } = props
  const children = useTreeNodeChildren(id)

  if (children.length === 0) return null

  return (
    <>
      {children.map(({ hasChildren, payload, id }) => {
        if (!payload) return null

        return (
          <TreeNode
            key={id}
            id={id}
            depth={depth}
            icon={
              <InView onChange={inView => inView && onLastItemVisible()}>
                {payload.__typename === 'Project' ? (
                  <Icon>
                    <ProjectIcon project={payload} isOpen={false} />
                  </Icon>
                ) : (
                  <WorkspaceLogo
                    size="17px"
                    workspaceName={payload?.name || ''}
                    src={payload.avatar?.small || payload.avatar?.large}
                  />
                )}
              </InView>
            }
            canCreateNestedProjects={false}
            hasChildren={hasChildren}
            label={
              <HighlightedText search={search}>
                {payload?.name || ''}
              </HighlightedText>
            }
          >
            <Node
              key={id}
              id={id}
              depth={depth + 1}
              search={search}
              lastItemId={lastItemId}
              onLastItemVisible={onLastItemVisible}
            />
          </TreeNode>
        )
      })}
    </>
  )
}
